export default __webpack_public_path__ + "static/media/ic_doge_24.523287f9.svg";